module.exports = __webpack_public_path__ + "static/img/logo-malaysian-bar-council@3x.c2d0268.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-malaysian-bar-council@3x.png
// module id = 9Suf
// module chunks = 7